<div class="field-date-wrapper">
  <div class="date-ans" *ngIf="!isInput">
    {{dateDisplay}}
  </div>

  <div class="date-input date-picker-wrapper" *ngIf="isInput">
    <input type="text"
           class="form-control"
           placement="top"
           #dp="bsDatepicker"
           bsDatepicker 
           [bsConfig]="dateInputConfig"
           [(ngModel)]="dateInput"
           (bsValueChange)="onChange($event)">
    <i class="fa fa-fw fa-calendar-o text-color-primary" (click)="setTodayDate()"></i>
  </div>
</div>